import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Reveal from './Reveal';

const { FiArrowUpRight } = FiIcons;

function CtaBand({ title = 'Ready to see what your space could become?' }) {
  return (
    <section className="bg-brick text-white">
      <div className="wrap flex flex-col items-start justify-between gap-8 py-20 md:flex-row md:items-center">
        <Reveal>
          <h2 className="h-display max-w-2xl text-5xl md:text-6xl">{title}</h2>
        </Reveal>
        <Reveal delay={0.1}>
          <Link to="/contact" className="btn bg-white text-ink hover:bg-ink hover:text-white">
            Request a Quote <SafeIcon icon={FiArrowUpRight} className="text-base" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}

export default CtaBand;
